"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToDomElement = exports.scrollToElement = void 0;
function scrollToElement(selector) {
    var scrollToElement = document.querySelector(selector);
    scrollToElement === null || scrollToElement === void 0 ? void 0 : scrollToElement.scrollIntoView({
        behavior: 'auto',
        block: 'start',
        inline: 'center'
    });
}
exports.scrollToElement = scrollToElement;
function scrollToDomElement(element) {
    element === null || element === void 0 ? void 0 : element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'center'
    });
}
exports.scrollToDomElement = scrollToDomElement;
